import { z } from 'zod';
/** What a vendor's quote or invoice may be read from: a PDF or a picture of one. */
export const QUOTE_IMPORT_MIME_TYPES = [
    'application/pdf',
    'image/jpeg',
    'image/png',
    'image/webp',
    'image/tiff',
];
/** `POST /quote-import/upload-url` — where the browser puts the file to be read. */
export const quoteImportUploadUrlSchema = z.object({
    fileName: z
        .string()
        .trim()
        .min(1)
        .max(255)
        .refine((n) => !n.includes('/') && !n.includes('\\'), 'Not a file name'),
    mimeType: z.enum(QUOTE_IMPORT_MIME_TYPES),
});
/**
 * `POST /quote-import/analyze` — read a document already on file, or the file
 * just uploaded through `upload-url` (the key it answered), which becomes a
 * document the figures can then be filed with.
 */
export const quoteImportRequestSchema = z.union([
    z.object({
        eventId: z.string().uuid(),
        documentId: z.string().uuid(),
    }),
    z.object({
        eventId: z.string().uuid(),
        s3Key: z.string().min(1).max(1024),
        fileName: z.string().trim().min(1).max(255),
        mimeType: z.enum(QUOTE_IMPORT_MIME_TYPES),
    }),
]);
export const quoteImportConfirmSchema = z.object({
    eventId: z.string().uuid(),
    documentId: z.string().uuid(),
    vendorId: z.string().uuid().optional(),
    vendorName: z.string().max(255).optional(),
    items: z.array(z.object({
        description: z.string(),
        quantity: z.number().min(0),
        unitPrice: z.number().min(0),
        totalPrice: z.number().min(0),
        category: z.string().optional(),
        accepted: z.boolean(),
        vendorCategoryId: z.string().uuid().optional(),
        statusId: z.string().uuid().optional(),
    })),
});
//# sourceMappingURL=quote-import.js.map